import { mergeProps } from '@zag-js/solid';
import { ark } from '../factory';
import { useComboboxContext } from './use-combobox-context';
import { useComboboxItemPropsContext } from './use-combobox-item-props-context';
export const ComboboxItemText = (props) => {
    const api = useComboboxContext();
    const itemProps = useComboboxItemPropsContext();
    const mergedProps = mergeProps(() => api().getItemTextProps(itemProps), props);
    return <ark.span {...mergedProps}/>;
};
